<template>
    <v-app-bar elevation="0" class="white" dense>
        <slot/>
    </v-app-bar>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.v-app-bar{
    border-bottom: 1px solid #EDEDED !important;
}

</style>